import { render, staticRenderFns } from "./attached-file-card.vue?vue&type=template&id=75c7ceaa"
import script from "./attached-file-card.vue?vue&type=script&lang=js"
export * from "./attached-file-card.vue?vue&type=script&lang=js"
import style0 from "./attached-file-card.vue?vue&type=style&index=0&id=75c7ceaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports